import PageHead from "../Head";
import HeaderStyleTen from "@/components/Header/HeaderStyle-Ten";
import Separator from "@/components/Common/Separator";
import MobileMenu from "@/components/Header/MobileMenu";
import Cart from "@/components/Header/Offcanvas/Cart";
import Context from "@/context/Context";
import { Provider } from "react-redux";
import Store from "@/redux/store";
import FooterThree from "@/components/Footer/Footer-Three";
import { ParallaxProvider } from "react-scroll-parallax";
import About from "@/components/Abouts/About";
import AboutFive from "@/components/Abouts/About-Five";
import Footersection from "@/components/Category/Footersection";
import Link from "next/link";

const stats = [
  { value: "12,000+", label: "Students Helped" },
  { value: "20+", label: "Countries Covered" },
  { value: "12+", label: "Years of Experience" },
  { value: "98%", label: "Visa Success Rate" },
];

const AboutC = () => {
  return (
    <>
      <PageHead title="About Us - The Immigration Gurus"
        description="Meet The Immigration Gurus — over 10 years guiding Indian students abroad, 1,000+ students counselled and 100+ global university partnerships." />

      <Provider store={Store}>
        <Context>
          <MobileMenu />
          <HeaderStyleTen headerSticky="rbt-sticky" headerType="" />
          <Cart />

          {/* ── Hero Banner ── */}
          <div
            style={{
              background: "linear-gradient(135deg, #0e142e 0%, #9d5618 100%)",
              padding: "110px 0 80px",
              position: "relative",
              overflow: "hidden",
            }}
          >
            {/* decorative circles */}
            <span style={{ position:"absolute", top:"-80px", right:"-80px", width:"380px", height:"380px", borderRadius:"50%", background:"rgba(255,255,255,0.04)", pointerEvents:"none" }} />
            <span style={{ position:"absolute", bottom:"-60px", left:"-60px", width:"260px", height:"260px", borderRadius:"50%", background:"rgba(255,255,255,0.04)", pointerEvents:"none" }} />

            <div className="container" style={{ position:"relative", zIndex:1 }}>
              <div className="row align-items-center">
                <div className="col-lg-8 col-md-10">
                  <span
                    style={{
                      display:"inline-block",
                      background:"rgba(219,104,39,0.2)",
                      border:"1px solid rgba(219,104,39,0.5)",
                      color:"#DB6827",
                      fontSize:"13px",
                      fontWeight:"700",
                      letterSpacing:"1.5px",
                      textTransform:"uppercase",
                      padding:"6px 18px",
                      borderRadius:"100px",
                      marginBottom:"22px",
                    }}
                  >
                    Know About Us
                  </span>
                  <h1
                    style={{
                      color:"#fff",
                      fontWeight:"800",
                      fontSize:"clamp(36px, 5vw, 58px)",
                      lineHeight:"1.18",
                      marginBottom:"22px",
                    }}
                  >
                    The Immigration<br />
                    <span style={{ color:"#DB6827" }}>Consultants in India</span>
                  </h1>
                  <p
                    style={{
                      color:"rgba(255,255,255,0.75)",
                      fontSize:"17px",
                      lineHeight:"1.75",
                      maxWidth:"620px",
                      marginBottom:"36px",
                    }}
                  >
                    The Immigration Gurus helps Indian students with expert
                    guidance, visa support, and personalised assistance to make
                    studying abroad easier and stress-free.
                  </p>
                  <div style={{ display:"flex", gap:"16px", flexWrap:"wrap" }}>
                    <button
                      className="rbt-btn btn-gradient radius-round"
                      style={{ border: "none", cursor: "pointer" }}
                      onClick={() =>
                        document
                          .getElementById("contact-form")
                          ?.scrollIntoView({ behavior: "smooth" })
                      }
                    >
                      Get Free Consultation
                    </button>
                    <Link
                      href="/elements/gallery"
                      style={{
                        display:"inline-flex",
                        alignItems:"center",
                        gap:"8px",
                        color:"#fff",
                        fontWeight:"600",
                        fontSize:"15px",
                        padding:"12px 24px",
                        borderRadius:"100px",
                        border:"1px solid rgba(255,255,255,0.35)",
                        textDecoration:"none",
                        transition:"border-color 0.2s",
                      }}
                    >
                      View Gallery
                    </Link>
                  </div>
                </div>
              </div>

              {/* Stats bar */}
              <div
                className="row g-3 mt-5"
                style={{
                  background:"rgba(255,255,255,0.07)",
                  border:"1px solid rgba(255,255,255,0.13)",
                  borderRadius:"16px",
                  padding:"28px 16px",
                  backdropFilter:"blur(8px)",
                }}
              >
                {stats.map((s, i) => (
                  <div key={i} className="col-6 col-md-3 text-center">
                    <h2
                      style={{
                        color:"#DB6827",
                        fontWeight:"800",
                        fontSize:"clamp(28px, 4vw, 40px)",
                        marginBottom:"4px",
                      }}
                    >
                      {s.value}
                    </h2>
                    <p style={{ color:"rgba(255,255,255,0.75)", fontSize:"14px", marginBottom:0 }}>
                      {s.label}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* ── Who We Are ── */}
          <div className="rbt-about-area about-style-1 bg-color-white rbt-section-gap">
            <ParallaxProvider>
              <About />
            </ParallaxProvider>
          </div>

          {/* ── Why Choose Us ── */}
          <WhyChooseUs />

          {/* ── Our Founders ── */}
          <div
            style={{
              background:"linear-gradient(25deg, rgb(14,20,46) 50%, rgb(157,86,24) 100%)",
              padding:"80px 0",
            }}
          >
            <div className="container">
              <div className="section-title text-center mb-5">
                <h2 className="title" style={{ color:"#fff" }}>
                  Leading Your Journey{" "}
                  <span style={{ color:"#DB6827" }}>Beyond Borders</span>
                </h2>
                <p style={{ color:"rgba(255,255,255,0.65)", maxWidth:"640px", margin:"12px auto 0", fontSize:"15px" }}>
                  Meet the visionaries behind Immigration Gurus, dedicated to
                  making international education and immigration journeys
                  simpler, smoother, and more successful.
                </p>
              </div>
              <AboutFive />
            </div>
          </div>

          {/* ── CTA / Contact Form ── */}
          <div className="rbt-about-area about-style-1 bg-color-white rbt-section-gap">
            <ParallaxProvider>
              <Footersection />
            </ParallaxProvider>
          </div>

          <Separator />
          <FooterThree />
        </Context>
      </Provider>
    </>
  );
};

/* ── Why Choose Us inline section ── */
const features = [
  {
    icon: "feather-award",
    title: "Industry-Leading Expertise",
    desc: "Over 15 years of experience navigating complex visa and immigration processes across 20+ countries.",
    color: "#DB6827",
    bg: "#fff7f0",
  },
  {
    icon: "feather-users",
    title: "Personalised Counselling",
    desc: "One-on-one sessions tailored to your academic profile, budget, and career goals.",
    color: "#2563eb",
    bg: "#eff6ff",
  },
  {
    icon: "feather-shield",
    title: "98% Visa Success Rate",
    desc: "Our meticulous documentation and prep process ensures industry-leading approval rates.",
    color: "#16a34a",
    bg: "#f0fdf4",
  },
  {
    icon: "feather-headphones",
    title: "End-to-End Support",
    desc: "From shortlisting universities to post-landing assistance — we are with you every step.",
    color: "#9333ea",
    bg: "#faf5ff",
  },
  {
    icon: "feather-globe",
    title: "Global University Network",
    desc: "Strong partnerships with top-ranked universities in the UK, Canada, Australia, USA & more.",
    color: "#0891b2",
    bg: "#ecfeff",
  },
  {
    icon: "feather-check-circle",
    title: "Transparent Process",
    desc: "No hidden fees, no false promises — just honest, clear guidance at every stage.",
    color: "#DB6827",
    bg: "#fff7f0",
  },
];

const WhyChooseUs = () => (
  <div style={{ background:"#f8fafc", padding:"80px 0" }}>
    <div className="container">
      <div className="section-title text-center mb-5">
        <span
          style={{
            color:"#DB6827",
            fontWeight:"700",
            fontSize:"13px",
            letterSpacing:"1.5px",
            textTransform:"uppercase",
            display:"block",
            marginBottom:"12px",
          }}
        >
          Our Strengths
        </span>
        <h2 className="title">
          Why Choose <span style={{ color:"#DB6827" }}>Immigration Gurus?</span>
        </h2>
        <p style={{ color:"#6b7280", maxWidth:"520px", margin:"14px auto 0", fontSize:"15px", lineHeight:"1.7" }}>
          We combine expertise, empathy, and experience to guide you towards the
          right international education destination.
        </p>
      </div>

      <div className="row g-4">
        {features.map((f, i) => (
          <div key={i} className="col-lg-4 col-md-6 col-12">
            <div
              style={{
                background:"#fff",
                borderRadius:"14px",
                padding:"32px 28px",
                height:"100%",
                boxShadow:"0 2px 16px rgba(0,0,0,0.07)",
                transition:"transform 0.2s, box-shadow 0.2s",
                border:"1px solid #f1f5f9",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-4px)";
                e.currentTarget.style.boxShadow = "0 8px 28px rgba(0,0,0,0.12)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "0 2px 16px rgba(0,0,0,0.07)";
              }}
            >
              <div
                style={{
                  width:"52px",
                  height:"52px",
                  borderRadius:"12px",
                  background:f.bg,
                  display:"flex",
                  alignItems:"center",
                  justifyContent:"center",
                  marginBottom:"20px",
                }}
              >
                <i className={f.icon} style={{ fontSize:"22px", color:f.color }} />
              </div>
              <h5 style={{ fontWeight:"700", color:"#0f172a", marginBottom:"10px", fontSize:"17px" }}>
                {f.title}
              </h5>
              <p style={{ color:"#64748b", fontSize:"14px", lineHeight:"1.7", marginBottom:0 }}>
                {f.desc}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  </div>
);

export default AboutC;

export async function getServerSideProps() {
  return { props: {} };
}
